export default __webpack_public_path__ + "static/media/icon-googlepay.38312e1be6247efe7cb697204f6b3e1b.svg";